import React from "react";
import PropTypes from "prop-types";
import Fieldset from "../../common/Fieldset";
import DownloadUploadFiles from "../../common/DownloadUploadFiles";
import RadioButtonChild from "../../common/RadioButtonWithChild";
import FieldsetSubHeader from "../../common/FieldsetSubHeader";
import RadioButtonText from "../../common/RadioButtonText";
import { Link } from "react-router";

import * as domainConstants from "../../../constants/DomainConstants";

const PlannenForm = props => {

    const PLANNEN_TOOLTIP = "Het toevoegen van architecturale plannen kan jouw dossier versterken.";
    const {
        beoordelingscriteria,
        disabled,
        errors,
        onChange,
		documenten,
        color,
        fileTypes,
        mapDeleteFile,
        mapDropFiles,
        getFilesForDossierComponent,
        fileSessionStarted,
        voorbeeldInplantingsplanURL,
        validationMessageType
    } = props;

	const jaNee = [{ value: "true", label: 'Ja' }, { value: "false", label: 'Nee' }];

    function hasFilesForDossierComponent(component) {
        if (documenten && documenten.find(x => x.name === component)) {
			const files = documenten.find(x => x.name === component).files;
			if (files) {
				return files.length > 0 ? true : false;
			}
		}
		return false;
    }

    const uploadComponentPlannen = (
        <DownloadUploadFiles
            dossierId={beoordelingscriteria.dossierId}
            title="Plannen"
            optional
            center
            disabled={disabled}
            color={color}
            tab={domainConstants.DocumentTab.Criteria}
            component={domainConstants.ComponentName.ArchitectPlannen}
            onDelete={mapDeleteFile(domainConstants.ComponentName.ArchitectPlannen)}
            onDrop={mapDropFiles(domainConstants.ComponentName.ArchitectPlannen)}
            files={getFilesForDossierComponent(domainConstants.ComponentName.ArchitectPlannen)}
            fileTypes={fileTypes.ArchitectPlannen}
            validationMessage={errors ? errors.ulNieuweTechnologieen : ""}
            validationMessageType={validationMessageType}
            fileSessionStarted={fileSessionStarted} />
    );

    const uploadComponentInplantingsplanVoorDeWerken = (
        <DownloadUploadFiles
            dossierId={beoordelingscriteria.dossierId}
            title="Inplantingsplan vóór de werken"
            size={6}
            disabled={disabled}
            color={color}
            tab={domainConstants.DocumentTab.Criteria}
            component={domainConstants.ComponentName.InplantingsplanVoorDeWerken}
            onDelete={mapDeleteFile(domainConstants.ComponentName.InplantingsplanVoorDeWerken)}
            onDrop={mapDropFiles(domainConstants.ComponentName.InplantingsplanVoorDeWerken)}
            files={getFilesForDossierComponent(domainConstants.ComponentName.InplantingsplanVoorDeWerken)}
            fileTypes={fileTypes.InplantingsplanVoorDeWerken}
            validationMessage={errors ? errors.ulInplantingsplanVoorDeWerken : ""}
            validationMessageType={validationMessageType}
            fileSessionStarted={fileSessionStarted} />
    );

    const uploadComponentInplantingsplanNaDeWerken = (
        <DownloadUploadFiles
            dossierId={beoordelingscriteria.dossierId}
            title="Inplantingsplan na de werken"
            size={6}
            disabled={disabled}
            color={color}
            tab={domainConstants.DocumentTab.Criteria}
            component={domainConstants.ComponentName.InplantingsplanNaDeWerken}
            onDelete={mapDeleteFile(domainConstants.ComponentName.InplantingsplanNaDeWerken)}
            onDrop={mapDropFiles(domainConstants.ComponentName.InplantingsplanNaDeWerken)}
            files={getFilesForDossierComponent(domainConstants.ComponentName.InplantingsplanNaDeWerken)}
            fileTypes={fileTypes.InplantingsplanNaDeWerken}
            validationMessage={errors ? errors.ulInplantingsplanNaDeWerken : ""}
            validationMessageType={validationMessageType}
            fileSessionStarted={fileSessionStarted} />
    );

    return (
        <Fieldset title="Plannen" tooltip={PLANNEN_TOOLTIP} tooltipWindowWidth={35} tooltipWindowAlignRight={false}>
            <RadioButtonText
				label="Zijn er architecturale plannen, bouwplannen, tekeningen of schetsen van het sportinfrastructuurproject beschikbaar?"
				name="plannenBeschikbaar"
				value={beoordelingscriteria.plannenBeschikbaar || hasFilesForDossierComponent(domainConstants.ComponentName.ArchitectPlannen)}
				onChange={onChange}
				size={12}
				disabled={disabled}
				locked={hasFilesForDossierComponent(domainConstants.ComponentName.ArchitectPlannen)}
				items={jaNee}
				horizontal
				validationMessage={errors ? errors.plannenBeschikbaar : ''}
				validationMessageType={validationMessageType}
			/>
            {beoordelingscriteria.plannenBeschikbaar == true || beoordelingscriteria.plannenBeschikbaar === "true" || hasFilesForDossierComponent(domainConstants.ComponentName.ArchitectPlannen) ?
				uploadComponentPlannen
				: ""}
            
            <FieldsetSubHeader linkText={"Voorbeeld inplantingsplannen"} linkUrl={voorbeeldInplantingsplanURL}>Geef een inplantingsplan van vóór en na de werken.</FieldsetSubHeader>
            {uploadComponentInplantingsplanVoorDeWerken}
            {uploadComponentInplantingsplanNaDeWerken}
        </Fieldset>
    );
};

PlannenForm.propTypes = {
    beoordelingscriteria: PropTypes.object.isRequired,
    disabled: PropTypes.bool,
    errors: PropTypes.object,
    color: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    fileTypes: PropTypes.object,
    mapDeleteFile: PropTypes.func.isRequired,
    mapDropFiles: PropTypes.func.isRequired,
    getFilesForDossierComponent: PropTypes.func.isRequired,
    fileSessionStarted: PropTypes.bool,
    validationMessageType: PropTypes.string,
    voorbeeldInplantingsplanURL: PropTypes.string,
    documenten: PropTypes.array,
};

export default PlannenForm;